import React from "react";
import { Drawer } from "antd";
import ExportCSVReport from "../../../../components/ExportCSVReport";

const ViewReport: React.FC<any> = (props) => {
  const { handleViewReport, openUpdateModal, openUpdateData } = props;

  const viewData = openUpdateData?.response
    ? JSON.parse(openUpdateData?.response)
    : null;

  const monthlyData = (data: any) => {
    // Ensure the data is wrapped in an array for consistent processing
    const dataArray = Array.isArray(data) ? data : [data];

    return (
      <>
        <thead>
          <tr>
            <th>To Provider</th>
            <th>To Provider Id</th>
            <th>To Provider Name</th>
            <th>Number Of Ports</th>
            <th>From Provider</th>
            <th>From Provider Id</th>
            <th>From Provider Name</th>
            <th>Total Phone Numbers</th>
            <th>Month</th>
          </tr>
        </thead>
        <tbody>
          {dataArray.length > 0 ? (
            dataArray.map((item: any, index: number) => (
              <tr key={index}>
                <td>{item.from_provider}</td>
                <td>{item.from_provider_id}</td>
                <td>{item.from_provider_name}</td>
                <td>{item.number_of_ports}</td>
                <td>{item.to_provider}</td>
                <td>{item.to_provider_id}</td>
                <td>{item.to_provider_name}</td>
                <td>{item.total_phone_numbers}</td>
                <td>{item.month}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={5}>No Data Found</td>
            </tr>
          )}
        </tbody>
      </>
    );
  };

  const weeklyData = (data: any) => {
    // Ensure the data is wrapped in an array for consistent processing
    const dataArray = Array.isArray(data) ? data : [data];

    return (
      <>
        <thead>
          <tr>
            <th>To Provider</th>
            <th>To Provider Id</th>
            <th>To Provider Name</th>
            <th>Number Of Ports</th>
            <th>From Provider</th>
            <th>From Provider Id</th>
            <th>From Provider Name</th>
            <th>Total Phone Numbers</th>
            <th>Week</th>
          </tr>
        </thead>
        <tbody>
          {dataArray.length > 0 ? (
            dataArray.map((item: any, index: number) => (
              <tr key={index}>
                <td>{item.from_provider}</td>
                <td>{item.from_provider_id}</td>
                <td>{item.from_provider_name}</td>
                <td>{item.number_of_ports}</td>
                <td>{item.to_provider}</td>
                <td>{item.to_provider_id}</td>
                <td>{item.to_provider_name}</td>
                <td>{item.total_phone_numbers}</td>
                <td>{item.week}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={5}>No Data Found</td>
            </tr>
          )}
        </tbody>
      </>
    );
  };

  const dailyData = (data: any) => {
    // Ensure the data is wrapped in an array for consistent processing
    const dataArray = Array.isArray(data) ? data : [data];

    return (
      <>
        <thead>
          <tr>
            <th>To Provider</th>
            <th>To Provider Id</th>
            <th>To Provider Name</th>
            <th>Number Of Ports</th>
            <th>From Provider</th>
            <th>From Provider Id</th>
            <th>From Provider Name</th>
            <th>Total Phone Numbers</th>
            <th>Day</th>
          </tr>
        </thead>
        <tbody>
          {dataArray.length > 0 ? (
            dataArray.map((item: any, index: number) => (
              <tr key={index}>
                <td>{item.from_provider}</td>
                <td>{item.from_provider_id}</td>
                <td>{item.from_provider_name}</td>
                <td>{item.number_of_ports}</td>
                <td>{item.to_provider}</td>
                <td>{item.to_provider_id}</td>
                <td>{item.to_provider_name}</td>
                <td>{item.total_phone_numbers}</td>
                <td>{item.day}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={5}>No Data Found</td>
            </tr>
          )}
        </tbody>
      </>
    );
  };
  const quarterData = (data: any) => {
    // Ensure the data is wrapped in an array for consistent processing
    const dataArray = Array.isArray(data) ? data : [data];

    return (
      <>
        <thead>
          <tr>
            <th>To Provider</th>
            <th>To Provider Id</th>
            <th>To Provider Name</th>
            <th>Number Of Ports</th>
            <th>From Provider</th>
            <th>From Provider Id</th>
            <th>From Provider Name</th>
            <th>Total Phone Numbers</th>
            <th>Quarter</th>
          </tr>
        </thead>
        <tbody>
          {dataArray.length > 0 ? (
            dataArray.map((item: any, index: number) => (
              <tr key={index}>
                <td>{item.from_provider}</td>
                <td>{item.from_provider_id}</td>
                <td>{item.from_provider_name}</td>
                <td>{item.number_of_ports}</td>
                <td>{item.to_provider}</td>
                <td>{item.to_provider_id}</td>
                <td>{item.to_provider_name}</td>
                <td>{item.total_phone_numbers}</td>
                <td>{item.quarter}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={5}>No Data Found</td>
            </tr>
          )}
        </tbody>
      </>
    );
  };

  const yearlyData = (data: any) => {
    // Ensure the data is wrapped in an array for consistent processing
    const dataArray = Array.isArray(data) ? data : [data];

    return (
      <>
        <thead>
          <tr>
            <th>To Provider</th>
            <th>To Provider Id</th>
            <th>To Provider Name</th>
            <th>Number Of Ports</th>
            <th>From Provider</th>
            <th>From Provider Id</th>
            <th>From Provider Name</th>
            <th>Total Phone Numbers</th>
            <th>Year</th>
          </tr>
        </thead>
        <tbody>
          {dataArray.length > 0 ? (
            dataArray.map((item: any, index: number) => (
              <tr key={index}>
                <td>{item.from_provider}</td>
                <td>{item.from_provider_id}</td>
                <td>{item.from_provider_name}</td>
                <td>{item.number_of_ports}</td>
                <td>{item.to_provider}</td>
                <td>{item.to_provider_id}</td>
                <td>{item.to_provider_name}</td>
                <td>{item.total_phone_numbers}</td>
                <td>{item.year}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={5}>No Data Found</td>
            </tr>
          )}
        </tbody>
      </>
    );
  };

  return (
    <Drawer
      open={openUpdateModal}
      destroyOnClose
      width={900}
      onClose={handleViewReport}
      footer={
        viewData ? (
          <div className="text-right">
            <ExportCSVReport
              elements={viewData}
              reportName={`internal-${openUpdateData.type}-${Date.now()}`}
              label={true}
            />
          </div>
        ) : (
          false
        )
      }
      className="addModal"
      title={`View Report`}
    >
      <table className="reportTable" width={"100%"}>
        {openUpdateData?.type === "monthly"
          ? monthlyData(viewData)
          : openUpdateData?.type === "weekly"
            ? weeklyData(viewData)
            : openUpdateData?.type === "quartely"
              ? quarterData(viewData)
              : openUpdateData?.type === "yearly"
                ? yearlyData(viewData)
                : dailyData(viewData)}
      </table>
      {/* {viewData?.length > 0 ? viewData.map((item: any) => monthlyData(item)) : null} */}
    </Drawer>
  );
};

export default ViewReport;
